import { useMemo } from 'react';

import { makeUrlParamsFromPath } from 'Internals/graph';

import type { DataEntityTab } from '../types/dataEntitiesTabs.types';

export const useFlowTabs = (
  subId: string,
  pathFromUrl: string | string[] | undefined
): DataEntityTab[] => {
  const query = pathFromUrl ? makeUrlParamsFromPath(pathFromUrl as string[]) : '';

  return useMemo(
    () => [
      {
        id: 'dashboard',
        testId: 'flow-tab-dashboard',
        label: 'Dashboard',
        tooltip: '',
        to: `/subscription/${subId}/flows/flow/dashboard?${query}`,
      },
      {
        id: 'config',
        testId: 'flow-tab-config',
        label: 'Config',
        tooltip: '',
        to: `/subscription/${subId}/flows/flow/config?${query}`,
      },
      {
        id: 'input',
        testId: 'flow-tab-input',
        label: 'Input',
        tooltip: 'The input of the first pipe of the flow',
        to: `/subscription/${subId}/flows/flow/input?${query}`,
      },
      {
        id: 'output',
        testId: 'flow-tab-output',
        label: 'Output',
        tooltip: 'The output of the last pipe of the flow',
        to: `/subscription/${subId}/flows/flow/output?${query}`,
      },
    ],
    [subId, query]
  );
};
